/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function ($) {
  $(".text-slide").jConveyorTicker({
    anim_duration: 200,
    reverse_elm: false,
  });
  $(".faq-wrapper .accordion .title").on("click", function () {
    $(this).closest(".accordion").toggleClass("active");
    
  });

  $(".product-meta .product-meta__reviews-badge").on("click", function (e){
    e.preventDefault();
    $(".reviews_tab").trigger("click");
    setTimeout(function() {
      $('html, body').animate({
        scrollTop: $("#stamped-main-widget").offset().top
      }, 1000); 
    },500)
  })

  $(window).on('load', () => {
        const element = $('.quote-image-slider');
        const mediaQuery = window.matchMedia('(max-width: 1052px)');

        const handleSwitchSlick = ((e) => {
            if (e.matches) {
                element.slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    dots: true

                });
            } else if (element.hasClass('slick-initialized')) {
                element.slick('unslick');
            }
        });

        mediaQuery.addListener(handleSwitchSlick);
        handleSwitchSlick(mediaQuery);
    });


  $('.timeline-main-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
    dots: false,
  asNavFor: '.timeline-control-slider'
});
$('.timeline-control-slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.timeline-main-slider',
  dots: false,
   arrows: false,
  centerMode: true,
  focusOnSelect: true,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
if($('.accordion-manual').length) {
  $(".accordion-manual .section__header").on("click", function () {
    $(this).closest(".accordion-manual").toggleClass("active");
    
  });
}
  
});


document.querySelectorAll('.scroll-link').forEach(link => {
    link.addEventListener('click', function (e) {
        e.preventDefault();

        // Get the target section ID from the href attribute
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
     
        if (targetElement) {
            // Perform the default scroll behavior
            const scrollOffset = targetElement.getBoundingClientRect().top + window.pageYOffset;


            // Adjust for header overlap after scroll completes
            setTimeout(() => {
                const header = document.querySelector('[data-section-id="header"]');
                const headerHeight = header ? header.offsetHeight : 0;

                // Additional top margin adjustment (if necessary)
                const targetStyle = window.getComputedStyle(targetElement);
                const targetMarginTop = parseInt(targetStyle.marginTop, 10) || 0;

                window.scrollTo({
                    top: window.pageYOffset - headerHeight,
                    behavior: 'auto', // Instant adjustment without animation
                });
            }, 600); // Adjust timeout to match the duration of your scroll animation
        }
    });
});


